import React from 'react';
import withView from "../../../../cmn/docAutomation/withView";
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormAttachment from '../../../../../library/form/components/FormAttachment';
import FormTitle from '../../../../../library/form/components/FormTitle';
import FormLink from '../../../../../library/form/components/FormLink';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import ActionButton from '../../../../../library/input/buttons/button/SarasButton';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import useViewSwitcher from '../../../../../library/hooks/switch/useViewSwitcher'
import SarasViewSwitch from '../../../../../library/hooks/switch/SarasViewSwitch'
import FormWrapper from "../../../../../library/form/components/FormWrapper"
import FormStatus from '../../../../../library/form/components/FormStatus';
import HoldStatus from "../../../components/HoldStatus";
import FormMenu from '../../../../../library/form/components/FormMenu';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiCol } from "../../../../../library/layout/Index";
import DocAdminInfo from '../../../../cmn/DocAdminInfo';

const ProdHeaderView = (props) => {
    const { formObject } = props;
    const headerViewSwitch = useViewSwitcher("summary");
    const holdStatusView = formObject?.childViews?.holdStatus;
    const holdStatusRefreshKey = JSON.stringify({
        viewRows: holdStatusView?.viewRows
    });

    const changeVisibility = (e, viewSwitch) => {
        if (viewSwitch) headerViewSwitch.onUpdateTriggerKey(viewSwitch);
    }

    // console.log("hold status", formObject?.childViews?.holdStatus);

    return (
        <>
            <SarasViewSwitch viewSwitcher={headerViewSwitch} ctrlKey='summary' hideMode='soft' >
                <UiView>
                    <UiViewHeading>
                        <div className="uiInline uiSpacerH5">
                            <FormAttachment imgHeight="50px" formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "targetItemImage" }} />
                        </div>
                        <div className="uiInline uiSpacerH10">
                            <ul>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />:
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiHighlightKey' />
                                </li>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priority" }} value="Priority" />
                                    </span>
                                    <FormROValue className="uiChip uiPriority" formObject={formObject} rowKey="" action={{ paramName: "priority" }} />
                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "queue" }} value="Queue" />
                                    </span>
                                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "queue" }} />
                                </li>
                            </ul>
                        </div>
                        <div className="uiInline uiSpacerH10">
                            <ul>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                                    </span>
                                    <FormWrapper customWrapper="span" formObject={formObject} rowKey="" action={{ paramName: "statusContainer" }} >
                                        <FormStatus formObject={formObject} rowKey="" headerKey="docStatus" className='uiBold' />
                                    </FormWrapper>
                                    <HoldStatus key={holdStatusRefreshKey} viewData={holdStatusView} className='uiSpacerH5 uiHighlightKey' />
                                </li>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requiredDate" }} value="Required Date" />
                                    </span>
                                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "requiredDate" }} className='uiHighlightKey' />
                                </li>
                            </ul>
                        </div>
                        <div className="uiInline uiSpacerH10">
                            <ul>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty" }} value="Qty" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty" }} className='uiHighlightKey' />
                                </li>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemId" }} value="Item ID" />:
                                    </span>
                                    <FormLink className="uiLink" formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                        action={{ paramName: "targetItemId", actionId: "show", actionName: "itemComp" }}
                                    />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "bomName" }}>
                                    <FormLink className="uiLink" formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                        text={<SarasTrans value="View BOM" />}
                                        action={{ paramName: "bomName", actionId: "show", actionName: "bomComp" }} />
                                </FormWrapper>
                            </ul>
                        </div>
                        <div className="uiInline uiSpacerH10">
                            <ul>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectType1" }} value="Ord Cat" />
                                    </span>
                                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "projectType1" }} className='uiHighlightKey' />
                                </li>
                                <li>
                                    <span className="uiLblS">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectType2" }} value="Ord Type" />
                                    </span>
                                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "projectType2" }} />
                                </li>
                            </ul>
                        </div>
                        <UiAction>
                            <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                            <FormButton formObject={formObject} ksc="h" rowKey="" className="" starIcon={"edit"}
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Edit Order"
                                action={{ actionId: "edit", actionParam: {}, containerKey: "popup" }}
                                ></FormButton>

                            <FormButton formObject={formObject} rowKey="" className="uiApproveIconButton" starIcon="approve"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Approve Order"
                                confirm="Are you sure to Approve the Order"
                                action={{ actionId: "refresh", paramName: "approveBtn", actionParam: { actionType: "approveJO" }, refreshMode:"self" }}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiRejectIconButton" starIcon="reject"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Reject Order"
                                confirm="Are you sure to Reject the Order"
                                action={{ actionId: "refresh", paramName: "rejectBtn", actionParam: { actionType: "rejectJO" }, refreshMode:"self" }}
                                ></FormButton>

                            <FormButton formObject={formObject} ksc="v" rowKey="" className="uiActionIconButton" starIcon={"variation"}
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Order Variation / Item Set Details"
                                action={{ actionId: "show", paramName: "variationBtn", actionName: "prodMatrixGroup", actionParam: { actionType: "matrixDetail" }, containerKey: "popup" }}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="hold"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Hold / Resume"
                                action={{ actionId: "new", actionName: "projectHold", paramName: "holdResumeBtn", 
                                actionParam: { actionType: "holdResumeJob" }, containerKey: "popup" }}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="cost"
                                    onlyIcon={true}
                                    starIconClassName="uiLink uiIcon"
                                    tooltip="Recalculate Cost"
                                    confirm="Recalculate order cost ?" action={{
                                    actionId: "refresh", paramName: "recalculateCostBtn",
                                    actionMessage: "Recalculate cost card", actionParam: { actionType: "recalculateCost" }
                                }} />
                            <FormMenu formObject={formObject}
                                directForSingle="1"
                                rowKey="" tooltip='Print' headerKey='print' starIcon={'print'}
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                action={{isCompHeader:1}}
                                className="uiActionIconButton" />
                            <div className="uiInline"></div>
                            <ActionButton starIcon="unfold" viewSwitch='detail' ksc="w" 
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Show More Details" 
                                onClick={changeVisibility} className='uiActionIconButton' text={<SarasTrans value="Show More" />}/>
                            <div className="uiInline uiSpacerL10"></div>
                            <FormButton formObject={formObject} ksc="search" headerKey="menu" tooltip="Search Order"
                                rowKey="" starIcon={'search'} className="uiActionIconButton"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                action={{ actionId: "search", isCompHeader: 1, paramName: "search" }} ></FormButton>
                            <div className="uiInline uiSpacerH5"></div>
                        </UiAction>
                    </UiViewHeading>
                </UiView>
            </SarasViewSwitch>
            <SarasViewSwitch viewSwitcher={headerViewSwitch} ctrlKey='detail' hideMode='soft' >
                <UiView>
                    <UiViewHeading>
                        <UiTitle>
                            <span><FormTitle formObject={formObject} value='Header' />: </span><FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} />
                        </UiTitle>
                        <UiAction>
                            <FormButton formObject={formObject} ksc="h" rowKey="" className="uiActionIconButton" starIcon={"edit"}
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Edit Order"
                                action={{ actionId: "edit", actionParam: {}, containerKey: "popup" }}
                                ></FormButton>

                            <FormButton formObject={formObject} rowKey="" className="uiApproveIconButton" starIcon="approve"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Approve Order"
                                action={{ actionId: "refresh", paramName: "approveBtn", actionParam: { actionType: "approveJO" }, refreshMode:"self" }}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiRejectIconButton" starIcon="reject"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Reject Order"
                                action={{ actionId: "refresh", paramName: "rejectBtn", actionParam: { actionType: "rejectJO" }, refreshMode:"self" }}
                                ></FormButton>

                            <FormButton formObject={formObject} ksc="v" rowKey="" className="uiActionIconButton" starIcon={"variation"}
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Order Variation / Item Set Details"
                                action={{ actionId: "show", paramName: "variationBtn", actionName: "prodMatrixGroup", actionParam: { actionType: "matrixDetail" }, containerKey: "popup" }}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="hold"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Hold / Resume"
                                action={{ actionId: "new", actionName: "projectHold", paramName: "holdResumeBtn",
                                actionParam: { actionType: "holdResumeJob" }, containerKey: "popup" }}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="cost"
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                    tooltip="Recalculate Cost"
                                    confirm="Recalculate order cost ?" action={{
                                    actionId: "refresh", paramName: "recalculateCostBtn",
                                    actionMessage: "Recalculate cost card", actionParam: { actionType: "recalculateCost" }
                                }} />
                            <FormMenu formObject={formObject}
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                directForSingle="1"
                                rowKey="" tooltip='Print' headerKey='print' starIcon={'print'}
                                action={{isCompHeader:1}}
                                className="uiActionIconButton" />
                            <div className="uiInline uiSpacerL10"></div>
                            <ActionButton starIcon="fold" viewSwitch='summary' ksc="s" 
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Show Less Details" 
                                onClick={changeVisibility} className='uiActionIconButton' text={<SarasTrans value="Show Less" />}/>
                            <div className="uiInline uiSpacerL10"></div>
                            <FormButton formObject={formObject} ksc="search" headerKey="menu" 
                                onlyIcon={true}
                                starIconClassName="uiLink uiIcon"
                                tooltip="Search Order"
                                rowKey="" starIcon={'search'} className="uiActionIconButton"
                                action={{ actionId: "search", isCompHeader: 1, paramName: "search" }}  ></FormButton>
                            <div className="uiInline uiSpacerH5"></div>
                        </UiAction>
                    </UiViewHeading>
                    <UiViewContent>
                        <div className="phViewAreaOrderHeader">
                            <div className="phViewImage">
                                <ul>
                                    <li>
                                        <FormAttachment formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "targetItemImage" }} />
                                    </li>
                                </ul>
                            </div>
                            <div className="phViewOrder uiFWGrid">
                                <UiCol>
                                    <ul>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                                            </span>
                                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiHighlightKey' />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectType1" }} value="Ord Cat" />:
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "projectType1" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectType2" }} value="Ord Type" />:
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "projectType2" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                                            </span>
                                            <FormStatus formObject={formObject} rowKey="" headerKey="docStatus" className='uiBold' />
                                            <HoldStatus key={`${holdStatusRefreshKey}-detail`} viewData={holdStatusView} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdOn" }} value="Created On" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "createdOn" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} value="Created By" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} />
                                        </li>
                                    </ul>
                                </UiCol>
                            </div>
                            <div className="phViewTarget uiFWGrid">
                                <UiCol>
                                    <ul>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemId" }} value="Item ID" />:
                                            </span>
                                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "targetItemId" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemName" }} value="Item Name" />:
                                            </span>
                                            <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                                action={{ paramName: "targetItemName", actionId: "show", actionName: "itemComp" }}
                                            />
                                        </li>
                                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "bomName" }}>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bomName" }} value="BOM" />:
                                            </span>
                                            <FormLink className="uiLink" formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                                action={{ paramName: "bomName", actionId: "show", actionName: "bomComp" }} />
                                        </FormWrapper>
                                        <li>
                                            <span className="uiLbl">
                                                <SarasTrans value = "Target Cat"/>
                                            </span>
                                            <span>
                                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "targetItemType1" }} /> <span>, </span>
                                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "targetItemType2" }} />
                                            </span>
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Customer" />
                                            </span>
                                            <FormLink className="uiLink" formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                                action={{ paramName: "profile", actionId: "show", actionName: "proComp" }}
                                            />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "specialInst" }} value="Instructions" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "specialInst" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "manager" }} value="Manager" />
                                            </span>
                                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "manager" }} />
                                        </li>
                                    </ul>
                                </UiCol>
                            </div>
                            <div className="phViewPlan uiFWGrid">
                                <UiCol>
                                    <ul>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty" }} value="Qty" />
                                            </span>
                                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requiredDate" }} value="Required Date" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "requiredDate" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priority" }} value="Priority" />
                                            </span>
                                            <FormROValue className="uiChip uiPriority" formObject={formObject} rowKey="" action={{ paramName: "priority" }} />
                                            <span className="uiLblInLine">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "queue" }} value="Queue" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "queue" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "planDate" }} value="Plan Date" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "planDate" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reserve" }} value="Reserve" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "reserve" }} />
                                            <span>%</span>
                                            <span className="uiLblInLine">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budget" }} value="Budget" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "budget" }} />
                                            <span className="uiLblInLine">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalCost" }} value="cost" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "totalCost" }} />
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comments" }} value="Comments" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "comments" }} />
                                        </li>
                                    </ul>
                                </UiCol>
                            </div>
                        </div>
                    </UiViewContent>
                </UiView>
            </SarasViewSwitch>
        </>
    )
}

export default withView(ProdHeaderView, "prodHeader", "prodCost");
